import Router from "./Router/Router";
import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import SupportPanel from "./components/support/SupportPanel";
import { CustomerServiceOutlined } from "@ant-design/icons";
import { antdSharedTheme } from "./theme/antdTokens";
import { muiColorTokens } from "./theme/muiTokens";

export default function AppWithSupport() {
  const { hotelDetails, showSupportIcon } = useSelector((store) => store.login);
  const { isMobileScreen } = useSelector((store) => store.appHeader);
  const [panelOpen, setPanelOpen] = useState(false);

  const showIcon = hotelDetails && showSupportIcon !== false && !isMobileScreen;

  // Brand-driven MUI theme. Built once; brand is fixed for the session.
  const muiTheme = useMemo(() => createTheme(muiColorTokens), []);

  return (
    <ConfigProvider theme={antdSharedTheme}>
      <ThemeProvider theme={muiTheme}>
        <Router />

        {showIcon && (
          <button
            onClick={() => setPanelOpen(true)}
            className="fixed bottom-6 right-6 z-[500] w-12 h-12 rounded-full bg-primary hover:bg-primary-hover text-fg-inverse shadow-lg flex items-center justify-center transition-colors"
            title="Support"
          >
            <CustomerServiceOutlined style={{ fontSize: 22 }} />
          </button>
        )}

        <SupportPanel open={panelOpen} onClose={() => setPanelOpen(false)} />
      </ThemeProvider>
    </ConfigProvider>
  );
}
